import { DesktopOutlined, MailOutlined, PhoneOutlined, ReadOutlined } from '@ant-design/icons';
import { Descriptions, Space } from 'antd';
import type { FC } from 'react';
import { openExternalLink } from '../utils/linkOpener';

export const HelpSupport: FC = () => {
  return (
    <Descriptions column={1} size="small" bordered>
      <Descriptions.Item
        label={
          <Space>
            <ReadOutlined /> Handbuch
          </Space>
        }
      >
        <a
          href="https://docs.medcom.at/docs/labcomplete/benutzerhandbuch"
          onClick={e => {
            e.preventDefault();
            openExternalLink('https://docs.medcom.at/docs/labcomplete/benutzerhandbuch');
          }}
        >
          Handbuch öffnen
        </a>
      </Descriptions.Item>
      <Descriptions.Item
        label={
          <Space>
            <PhoneOutlined /> Hotline
          </Space>
        }
      >
        <a href="tel:+4318693658">+43 1 869 36 58</a>
      </Descriptions.Item>
      <Descriptions.Item
        label={
          <Space>
            <MailOutlined /> E-Mail
          </Space>
        }
      >
        <a href="mailto:support@medcom.at">support@medcom.at</a>
      </Descriptions.Item>
      <Descriptions.Item
        label={
          <Space>
            <DesktopOutlined /> Fernwartung
          </Space>
        }
      >
        <a target="_blank" rel="noopener noreferrer" href="https://get.teamviewer.com/de/6a9ydch">
          Download TeamViewer
        </a>
      </Descriptions.Item>
    </Descriptions>
  );
};
